import { Product, ProductReference } from '@/types';
import { getParams } from '@/utils/params';
import { postToApiSigned } from './fetchFromApi';

export const createProduct = (product: Product) =>
  postToApiSigned<ProductReference>(
    `${getParams().context}s/${getParams().contextId}/products`,
    product,
    { mode: 'designer' }
  );
